import { render } from "./dyGoodsManage.vue?vue&type=template&id=611d847f"
import script from "./dyGoodsManage.vue?vue&type=script&lang=js"
export * from "./dyGoodsManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__